import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	offer: {
		id: 'amexglobal.welcome.offer',
		defaultMessage:
			'Calm and American Express are excited to bring this exclusive offer to eligible Cardmembers.',
		description: 'Amex Global offer text',
	},
	info: {
		id: 'amexglobal.welcome.info',
		defaultMessage: 'For information about Calm and Calm Premium, <infolink>click here</infolink>.',
		description: 'Amex Global info text',
	},
	offerDate: {
		id: 'amexglobal.welcome.offerDate',
		defaultMessage: 'You must sign up by 31 December 2020 using this site to take advantage of the offer',
		description: 'Amex Global more info text',
	},
	moreInfo: {
		id: 'amexglobal.welcome.moreTerms',
		defaultMessage:
			'For more information about this offer and which cards are eligible, see the American Express Calm <termslink>Offer Terms</termslink>.',
		description: 'Amex Global welcome more terms',
	},
	offerExpired: {
		id: 'amex.welcome.offerExpired',
		defaultMessage: "This offer has expired. However, we're excited to bring you a free Calm trial.",
		description: 'A promotional offer is no longer available',
	},
	tryCalmFree: {
		id: 'amex.welcome.tryCalmFree',
		defaultMessage: 'Try Calm for Free',
		description: 'A link to a free trial offer',
	},
});
